import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=68dc2e42&scoped=true&"
import script from "./insights.vue?vue&type=script&lang=js&"
export * from "./insights.vue?vue&type=script&lang=js&"
import style0 from "./insights.vue?vue&type=style&index=0&id=68dc2e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc2e42",
  null
  
)

export default component.exports